import {$createParagraphNode, $createTextNode, $getRoot} from "lexical"
import {
    $convertFromMarkdownString,
} from '@lexical/markdown'
import {MARKDOWN_TRANSFORMERS} from "./makrdown/transformers"

// const debug = "lexical_convertFromMarkdown"
const debug = false

export default function lexical_convertFromMarkdown(markdownText?: string) {
    if (!markdownText) return

    const root = $getRoot()
    if (root.getFirstChild() === null) {
        const paragraph = $createParagraphNode()
        paragraph.append(
            $createTextNode(markdownText)
        )
        root.append(paragraph)
    }

    const firstChild = root.getFirstChild()

    debug && console.log(debug, 'process', firstChild?.getTextContent(), markdownText)

    if (firstChild) {
        $convertFromMarkdownString(
            firstChild.getTextContent(),
            MARKDOWN_TRANSFORMERS,
            undefined, // node
        )
    }
}